const CONVERSION_RULE_MODES = {
    DEFAULT: 'DEFAULT',
    CUSTOM: 'CUSTOM',
};

export default CONVERSION_RULE_MODES;
